"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeUseCurrency = void 0;
const types_1 = require("../types");
const moneyfy_1 = require("./moneyfy");
const initializeUseCurrency = function () {
  let currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "GBP";
  let config = arguments.length > 1 ? arguments[1] : undefined;
  const currencySymbol = types_1.CURRENCY_SYMBOL_MAP[currency];
  return {
    toCurrency: (0, moneyfy_1.moneyfy)(currency, config),
    currencySymbol,
    currency
  };
};
exports.initializeUseCurrency = initializeUseCurrency;
exports.default = exports.initializeUseCurrency;